import { publicApi } from '@shared/config/axios.config';

interface ContactUsPayload {
  first_name: string;
  last_name: string;
  email: string;
  message: string;
}

export const contactUsApi = (payload: ContactUsPayload) => {
  return publicApi.post('/contact/message', payload);
};
